import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewContainerRef, AfterViewInit } from '@angular/core';
import { DataService, OptionsserviceService, LoansService, StorageService, CustomerService } from '../../_services/index';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';
import { IMyDateModel, IMyInputFieldChanged, IMyCalendarViewChanged, IMyInputFocusBlur, IMyMarkedDate, IMyDate, IMySelector } from 'mydatepicker';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-createrequestmodal',
  templateUrl: './createrequestmodal.component.html',
  styleUrls: ['./createrequestmodal.component.css']
})
export class CreaterequestmodalComponent implements OnInit {
  interestAlone = false;
  epi = false;
  bulconst = false;
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    height: '34px',
    width: '210px',
    dateFormat: 'yyyy-mm-dd',
    openSelectorTopOfInput: false,
  };
  public selDate: IMyDate = { year: 0, month: 0, day: 0 };
  public selDate_: IMyDate = { year: 0, month: 0, day: 0 };
  public submitted: boolean; // keep track on whether form is submitted
  public installment_frequency = '1';
  allowMoratorium = false;
  public installment_frequencies = [{ value: 1, display: 'One Off' }, { value: 2, display: 'Monthly' }];
  @Input('request_id') request_id: any;
  @Input('currentUser') currentUser: any;
  @Input('loan') loan: any;
  SEND_CONTRACT_DOCS = false;
  modifying_contract = false;
  showingMore = false;
  loading = false;
  public loan_durations = [{ 'LOAN_INTEREST_DURATION_ID': '1', 'LOAN_DURATION': 'Days', 'INTEREST_DURATION': 'Per Day', 'ADJECTIVAL': 'Daily', 'ABBREV': 'd' },
  { 'LOAN_INTEREST_DURATION_ID': '2', 'LOAN_DURATION': 'Months', 'INTEREST_DURATION': 'Per Month', 'ADJECTIVAL': 'Monthly', 'ABBREV': 'Mo' },
  { 'LOAN_INTEREST_DURATION_ID': '3', 'LOAN_DURATION': 'Years', 'INTEREST_DURATION': 'Per Year', 'ADJECTIVAL': 'Yearly', 'ABBREV': 'Yr' },
  { 'LOAN_INTEREST_DURATION_ID': '4', 'LOAN_DURATION': 'Weeks', 'INTEREST_DURATION': 'Per Week', 'ADJECTIVAL': 'Weekly', 'ABBREV': 'Wk' }];
  public installment_terms = [{ value: 0, display: 'Select' }, { value: 1, display: 'Equal Monthly Installment' }, { value: 2, display: 'Interest Alone' }, { value: 3, display: 'Bulconst' }, { value: 4, display: '' }, { value: 5, display: '' }, { value: 6, display: 'Reducing Balance' }];
  public monthly_period = [{ value: 0, display: 'Select' }, { value: 1, display: 'Monthly' }, { value: 2, display: '+28 days' }, { value: 3, display: '+29 days' }, { value: 4, display: '+30 days' }, { value: 5, display: '+3 days' }];
  loan_duration = 'Months';
  interest_duration = 'Per Month';
  countries: any;
  public rtypes = [{ value: 1, display: 'Equal Monthly Installment' }, { value: 2, display: 'Interest Alone' }, { value: 6, display: 'Reducing Balance' }];
  constructor(private toastr: ToastrService, vcr: ViewContainerRef, private DataService: DataService, public router: Router,
    public _fb: FormBuilder, public storageService: StorageService,
    public customerService: CustomerService,
    public optionsService: OptionsserviceService, public loansService: LoansService) {
    this.optionsService.getCountries().subscribe(countries => this.countries = countries);
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  ngAfterViewInit() {
    this.prefillDates();
  }
  ngOnInit() {
    const d: Date = new Date(this.loan.disbursement_date);

    this.selDate = {
      year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDate()
    };
    const d_: Date = new Date(this.loan.repayment_started_when);

    this.selDate_ = {
      year: d_.getFullYear(),
      month: d_.getMonth() + 1,
      day: d_.getDate()
    };
  }
  getNet() {
    let total = parseInt(this.loan.request_principal);
    if (this.loan.fee_type === '0') {
      total -= parseInt(this.loan.total_fees_charges)
    }
    return total;
  }
  createContract() {
    this.modifying_contract = !this.modifying_contract; 
  }
  createContract_() { 
    this.submitted = true; // set form submit to true
    this.loading = true;

    this.loansService.save_contract_(this.currentUser.token, this.loan, this.SEND_CONTRACT_DOCS)
      .subscribe(res => {
        this.loading = false;
        

      });
  }
  sendToMarket() {


  }
  changeDuration(d, T) {
    if (T === 1) {
      this.loan_duration = this.loan_durations[d]['LOAN_DURATION'];
      this.loan.request_period_id = this.loan_durations[d]['LOAN_INTEREST_DURATION_ID'];
    }
    if (T === 2) {

      this.interest_duration = this.loan_durations[d]['INTEREST_DURATION'];
      this.loan.request_rate_period_id = this.loan_durations[d]['LOAN_INTEREST_DURATION_ID'];


    }

  }
  changeRepay(event) {
    this.allowMoratorium = false;
    this.loan.allow_moratorium = '1';
    if (event == '1') {
      this.rtypes = [{ value: 1, display: 'Equal Monthly Installment' }];
    }
    if (event == '2') {
      this.rtypes = [{ value: 1, display: 'Equal Monthly Installment' }, { value: 2, display: 'Interest Alone' }, { value: 6, display: 'Reducing Balance' }];
    }
  }

  cIA(event) {

    this.interestAlone = false;
    this.epi = false;
    this.bulconst = false;
    this.allowMoratorium = false;
    this.loan.allow_moratorium = '1';
    this.loan.allow_moratorium = '1';
    if (event == '2') {
      this.interestAlone = true;
      this.epi = false;
      this.loan.repayment_type = 'Interest Alone';
      this.loan.interest_rate_type_id = 2;
    }
    if (event == '1') {
      this.epi = true;
      this.loan.REPAYMENT_TYPE = 'EPI';
    }
    if (event == '3') {
      this.bulconst = true;
    }
    if (event == '6') {
      this.loan.interest_rate_type_id = 2;
      this.loan.repayment_type = 'Reducing Balance';
    }
  }
  cIB(event) {

    this.allowMoratorium = false;

    if (event == '2') {
      this.allowMoratorium = true;
    }
  }

  changeInstallmentFrequency(event) {

    this.installment_frequency = event;

    this.allowMoratorium = false;
    this.loan.allow_moratorium = '1';
    if (this.installment_frequency === '1') {
      this.rtypes = [{ value: 3, display: 'Bulconst' }];
      this.loan.repayment_type_id = '3';
      this.loan.repayment_type = 'Bulconst';
    } else {
      this.rtypes = [{ value: 1, display: 'Equal Monthly Installment' }, { value: 2, display: 'Interest Alone' }, { value: 6, display: 'Reducing Balance' }];
      this.loan.repayment_type_id = '1';
      this.loan.repayment_type = 'EPI';
    }

  }
  prefillDates() {
    const data = {
      'DISBURSEMENT_DATE': this.loan.disbursement_date,
      'REQUEST_PERIOD_ID': this.loan.request_period_id,
      'MONTHLY_PERIOD': this.loan.monthly_period,
      'DAYS_PER_YEAR': this.loan.days_per_year,
    }
    this.loansService.modify_repay_date(data)
      .subscribe(loan => {
        const d_: Date = new Date(loan.repay);

        this.selDate_ = {
          year: d_.getFullYear(),
          month: d_.getMonth() + 1,
          day: d_.getDate()
        };

        const d: Date = new Date(loan.disburse);

        this.selDate = {
          year: d.getFullYear(),
          month: d.getMonth() + 1,
          day: d.getDate()
        };
        this.loan.disbursement_date = loan.disburse;
        this.loan.repayment_started_when = loan.repay;

      });
  }
  onDateChanged(event: IMyDateModel) {
    this.submitted = true;
    const data = {
      'DISBURSEMENT_DATE': event.formatted,
      'REQUEST_PERIOD_ID': this.loan.request_period_id,
      'MONTHLY_PERIOD': this.loan.monthly_period,
      'DAYS_PER_YEAR': this.loan.days_per_year,
    }
    this.loansService.modify_repay_date(data)
      .subscribe(loan => {
        const d_: Date = new Date(loan.repay);

        this.selDate_ = {
          year: d_.getFullYear(),
          month: d_.getMonth() + 1,
          day: d_.getDate()
        };

        const d: Date = new Date(loan.disburse);

        this.selDate = {
          year: d.getFullYear(),
          month: d.getMonth() + 1,
          day: d.getDate()
        };
        this.loan.disbursement_date = loan.disburse;
        this.loan.repayment_started_when = loan.repay;

      });
  }
}
